<template>
  <v-row justify="center">
    <v-dialog v-model="modal" max-width="550" @keydown.esc="cancel" persistent>
      <v-card>
        <v-card-title :class="[tipe, 'title', myClass[tipe]]">
          <v-icon :class="['mr-2', myClass[tipe]]">{{ myIcons[tipe] }}</v-icon>
          {{ title }}
        </v-card-title>
        <v-container class="grey lighten-2" v-if="items.length">
          <template v-for="(item, index) in items">
            <v-list v-if="item.title" :key="item.title" three-line expand>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar v-if="item.icon" :color="item.colorAvatar">
                    <v-icon :class="item.iconColor">{{ item.icon }}</v-icon>
                  </v-avatar>
                  <v-img v-else :src="$imgUrl(item.foto)" aspect-ratio="1" class="grey lighten-2"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="item.title" class="teal--text font-weight-bold"></v-list-item-title>
                  <template v-for="(item2, index2) in item.subtitles">
                    <v-list-item-subtitle v-html="item2" :key="index2"></v-list-item-subtitle>
                  </template>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider v-else :inset="item.inset" :key="index"></v-divider>
          </template>
        </v-container>
        <v-container grid-list-md v-if="form && form.render">
          <v-layout wrap class="pa-2">
            <span class="pa-1" v-html="form.desc"></span>
            <base-render :renderEl="form.render" :params="form.params"></base-render>
          </v-layout>
        </v-container>
        <v-card-text
          v-html="desc"
          :class="{ 'py-0': Object.keys(form).length, 'py-2': !Object.keys(form).length }"
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="modal = false"> Tidak </v-btn>
          <v-btn color="blue darken-1" text @click="agree"> Ya </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      title: null,
      desc: null,
      tipe: 'warning',
      items: [],
      form: '',
      resolve: null,
      reject: null,
      modal: false,
      confirmation: true,
      myIcons: {
        warning: 'mdi-alert',
        error: 'mdi-close-circle',
        info: 'mdi-information',
        success: 'mdi-check-circle',
      },
      myClass: {
        warning: '',
        error: ' white--text',
        info: ' white--text',
        success: ' white--text',
      },
    };
  },
  methods: {
    open(message, title, options = {}) {
      this.title = title || 'Konfirmasi';
      this.desc = message;

      // apply keterangan jika ada
      if (options) {
        this.items = options.data || [];
        this.tipe = options.tipe || this.tipe;
        this.form = options.form || {};
        this.confirmation = options.confirmation !== undefined ? options.confirmation : this.confirmation;
      }

      // contoh data
      // {
      //     icon: "fa-graduation-cap",
      //     iconClass: "grey lighten-1 white--text",
      //     title: "Nama Perguruan Tinggi",
      //     subtitles: [
      //       '<span class="text--primary">Nama Program Studi</span>',
      //       '<span class="text--primary">Nama Jurusan / Konsentrasi</span>',
      //       "2008 &mdash; 2012"
      //     ]
      //   }

      // open
      this.modal = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.modal = false;
      this.resolve(true);
    },

    cancel() {
      this.modal = false;
    },
  },
};
</script>
